module.exports = __webpack_public_path__ + "img/blue_156.93b8d904.png";